import React from 'react'

interface MiniBarChartProps {
  data?: number[]
  showAverage?: boolean
  className?: string
}

export const MiniBarChart: React.FC<MiniBarChartProps> = ({ 
  data = [13, 61, 34, 86, 100, 61, 53, 65, 90, 53, 67, 80, 67, 92, 46],
  showAverage = true,
  className 
}) => {
  return (
    <div className={`absolute h-[124px] overflow-hidden right-0 top-0 w-[185px] ${className || ''}`}>
      <div className="absolute bottom-0 flex gap-[6px] h-[100px] items-end left-0 w-[185px]">
        {data.map((height, index) => (
          <div
            key={index}
            className="bg-gradient-to-b flex-[1_0_0] from-[rgba(197,204,159,0.52)] to-[rgba(197,204,159,0.2)] min-h-px min-w-px rounded-tl-[12px] rounded-tr-[12px]"
            style={{ height: `${height}px` }}
          />
        ))}
      </div>
      
      {/* Average line indicator */}
      {showAverage && (
        <div className="absolute left-0 top-[68px] w-[185px]">
          <div className="flex h-0 items-center justify-center w-full">
            <div className="flex-none rotate-[180deg]">
              <div className="h-0 relative w-[185px]">
                <svg
                  className="absolute inset-[-0.75px_-0.41%_-0.75px_0] w-full h-[2px]"
                  viewBox="0 0 185 2"
                  preserveAspectRatio="none"
                >
                  <line
                    x1="0"
                    y1="1"
                    x2="185"
                    y2="1"
                    stroke="#313131"
                    strokeWidth="1.5"
                    strokeDasharray="3 3"
                  />
                </svg>
              </div>
            </div>
          </div>
          {/* Average label */}
          <div className="flex items-start absolute left-0 top-0 w-[26.402px]">
            <div className="bg-[#313131] dark:bg-[#e5e5e5] flex items-start overflow-clip pl-[4px] pr-[2px] py-px rounded-bl-[4px] rounded-tl-[4px]">
              <p className="font-['Plus_Jakarta_Sans'] font-medium leading-[18px] text-[13px] text-white dark:text-[#2d2923]">
                Avg
              </p>
            </div>
            {/* Arrow pointer */}
            <div className="flex h-[20px] items-center justify-center w-[10px]">
              <div className="flex-none rotate-[90deg]">
                <svg width="20" height="10" viewBox="0 0 20 10" fill="none">
                  <path
                    d="M10 0L20 10H0L10 0Z"
                    fill="#313131"
                    className="dark:fill-[#e5e5e5]"
                  />
                </svg>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

export default MiniBarChart
